import { z } from 'zod';
export const confidenceFlagSchema = z.enum(['high', 'medium', 'low']);
export const underwritingEventSchema = z.object({
    id: z.string(),
    conversationId: z.string(),
    userId: z.string(),
    versionLabel: z.string(),
    modelId: z.string(),
    confidenceFlag: confidenceFlagSchema,
    notes: z.string().optional(),
    assumptions: z.record(z.string(), z.any()),
    metrics: z.record(z.string(), z.any()),
    provenance: z.record(z.string(), z.any()),
    createdAt: z.string(),
});
